<template>
    <div class="search-portal">
        <form class="input-group" @submit.prevent="onSubmit">
            <input ref="input" type="text" aria-label="query" :placeholder="placeholder" v-model.trim="query" />
            <div class="input-group-append">
                <button type="submit" name="search">
                    <span class="fa fa-search form-control-feedback"></span>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            query: '',
            bodyClass: 'active-portal-search',
            placeholder: 'Pesquise...',
        }
    },
    watch: {
        '$route': function(value) {
            this.closeSearch();
        }
    },
    methods: {
        closeSearch: function() {
            if(document.body.classList.contains(this.bodyClass)) {
                document.body.classList.remove(this.bodyClass);
            }
        },
        inputIsShowed: function() {
            return this.$refs.input.offsetWidth != 0;
        },
        onSubmit: function() {
            if(this.query.length > 0) {
                this.$router.push({ name: 'portal.search', query: { q: this.query} });
                return;
            }
            if(!this.inputIsShowed()) {
                document.body.classList.add(this.bodyClass);
                return;
            }
            if(document.body.classList.contains(this.bodyClass)) {
                document.body.classList.remove(this.bodyClass);
                return;
            }

            this.$root.$helper.error.httpError({message:"O campo de pesquisa é obrigatório"});
        }
    },
    mounted() {
        this.closeSearch();
    },
}
</script>
